/**
 * @generated SignedSource<<7a01649ffa8eb308b8ad5a12c75c1d52>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberReportProductEventsAttendanceRateStatisticCardFragment$data = {
  readonly eventsAttendanceRateReport: {
    readonly allTime: number;
  };
  readonly " $fragmentType": "MemberReportProductEventsAttendanceRateStatisticCardFragment";
};
export type MemberReportProductEventsAttendanceRateStatisticCardFragment$key = {
  readonly " $data"?: MemberReportProductEventsAttendanceRateStatisticCardFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MemberReportProductEventsAttendanceRateStatisticCardFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startDate"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "MemberReportProductEventsAttendanceRateStatisticCardFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "productLevel",
          "value": true
        },
        {
          "kind": "Variable",
          "name": "startDate",
          "variableName": "startDate"
        }
      ],
      "concreteType": "GenericReportingResponse",
      "kind": "LinkedField",
      "name": "eventsAttendanceRateReport",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allTime",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "OrganizationMembership",
  "abstractKey": null
};

(node as any).hash = "c05b58e1a5540f8462d2da5e4f910995";

export default node;
